import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

// TODO: this entrypoint has no queries, no child entrypoints, and no extra props.
type ProductJsmAiGovernanceEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{},
	Record<string, never>
>;

export const productJsmAiGovernanceEntryPoint: EntryPoint<
	ProductJsmAiGovernanceEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProductJsmAiGovernanceEntryPointComponent>(
		/* webpackChunkName: "async-product-jsm-ai-governance", jiraSpaEntry: "async-product-jsm-ai-governance" */ './ProductJsmAiGovernancePage.tsx',
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => ({
		queries: {},
	}),
});
